import * as React from 'react';
import {ReactNode} from 'react';

type CallOutProps = {
    children: ReactNode;
};

export const CallOut = ({children}: CallOutProps) => {
    return <div className="tw-border-l-4 tw-border-l-blue-200 tw-border-y tw-border-r tw-p-3 tw-w-full">{children}</div>;
};
